import {
  DashboardLayout,
  FavoriteDashboardSortBy,
  QueueDashboardQueueSortBy,
} from 'lib-dashboard-types';

import { LayoutCompact } from './images/layoutCompact';
import { LayoutDefault } from './images/layoutDefault';
import { SortByNameAsc } from './images/sortByNameAsc';
import { SortByNameDesc } from './images/sortByNameDesc';
import { SortByPriorityAsc } from './images/sortByPriorityAsc';
import { SortByPriorityDesc } from './images/sortByPriorityDesc';

type DashboardPreferencesAsset<TValue extends string> = {
  readonly value: TValue;
  readonly label: string;
  readonly image: JSX.Element;
};

export const queueSortByPreferenceAssets: readonly DashboardPreferencesAsset<QueueDashboardQueueSortBy>[] =
  [
    { value: 'name:asc', label: 'A - Z', image: <SortByNameAsc /> },
    { value: 'name:desc', label: 'Z - A', image: <SortByNameDesc /> },
    {
      value: 'priority:asc',
      label: 'Highest priority',
      image: <SortByPriorityAsc />,
    },
    {
      value: 'priority:desc',
      label: 'Lowest priority',
      image: <SortByPriorityDesc />,
    },
  ];

export const favoriteSortByPreferenceAssets: readonly DashboardPreferencesAsset<FavoriteDashboardSortBy>[] =
  [
    { value: 'name:asc', label: 'A - Z', image: <SortByNameAsc /> },
    { value: 'name:desc', label: 'Z - A', image: <SortByNameDesc /> },
    {
      value: 'updated_at:desc',
      label: 'Recently updated',
      image: <SortByPriorityAsc />,
    },
    {
      value: 'updated_at:asc',
      label: 'Oldest updated',
      image: <SortByPriorityDesc />,
    },
    {
      value: 'shared:desc',
      label: 'Shared first',
      image: <SortByPriorityAsc />,
    },
    {
      value: 'shared:asc',
      label: 'Not shared first',
      image: <SortByPriorityDesc />,
    },
  ];

export const layoutPreferenceAssets: readonly DashboardPreferencesAsset<DashboardLayout>[] =
  [
    { value: 'default', label: 'Default', image: <LayoutDefault /> },
    { value: 'compact', label: 'Compact', image: <LayoutCompact /> },
  ];
